import { Capacitor } from '@capacitor/core';

export const isWeb = () => Capacitor.getPlatform() === 'web';
export const isNative = () => {
  try {
    return Capacitor.isNativePlatform?.() ?? (Capacitor.getPlatform() !== 'web');
  } catch {
    return false;
  }
};
